import {
    RESET_ALL_COMPANIES,
    SAVE_ALL_COMPANIES,
} from "../types";

const INITIAL_STATE = {
    companies: {
        list: [],
        showViewMore: false,
        pageNumber: 1,
        pageSize: 500,
    },
    companyDetails: {
        details: {},
        list: [],
        showViewMore: false,
        pageNumber: 1,
        pageSize: 200,
    },
};

const companiesReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {

        case SAVE_ALL_COMPANIES:
            return {
                ...state,
                companies: {
                    pageSize: 10,
                    ...payload,
                },
            };

        case RESET_ALL_COMPANIES:
            return {
                ...state,
                companies: INITIAL_STATE.companies,
            };

        default:
            return state;
    }
};

export default companiesReducer;
